export default __webpack_public_path__ + "static/media/hostfully.68a2f189.png";